
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/frequently-asked-questions",
      function () {
        return require("private-next-pages/web/frequently-asked-questions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/frequently-asked-questions"])
      });
    }
  